import { getBonusPointProducts, getBonusPointsProduct, getHotProducts, getProduct, getProducts } from '@/api/product'
import Axios from 'axios'

const axiosSource = {
  items: undefined,
  hotItems: undefined,
  bonusPointsItems: undefined,
  max_page: undefined,
}

const product = {
  namespaced: true,
  state: () => ({
    status: {
      items: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      max_page: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      hotItems: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      bonusPointsItems: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      bonusPointsDetails: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      details: {
        initialized: false,
        refreshing: false,
        error: false,
      }
    },
    items: [],
    hotItems: [],
    bonusPointsItems: [],
    max_page: 0,
    details: {
      id: undefined,
      imageUrl: '',
      supplierInfoTitle: '',
      supplierInfoDescription: '',
      name: '',
      description: '',
      californiaProposition65: undefined,
      versions: [],
      supplierName: '',
      terms: ''
    },
    bonusPointsDetails: {
      id: undefined,
      name: '',
      description: '',
      imageUrl: '',
      californiaProposition65: undefined,
      versions: [],
    },
    bonusPointsChosenVersion: {
      productId: 0,
      productVersionId: 0,
    },
    sortOrder: undefined,
  }
  ),
  getters: {}
  ,
  actions: {
    fetchProducts ({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'items')
        commit('SET_ERROR_FALSE', 'items')
        if (axiosSource.items) {
          axiosSource.items.cancel()
        }
        axiosSource.items = Axios.CancelToken.source()

        // const limit = 20
        let offset = 0
        if (data.page) {
          offset = data.page * data.limitFilter
        }
        getProducts(data.categoryId, offset, data.limitFilter, data.searchFilter, data.sortOrder, axiosSource.items.token, data.pointFilter)
          .then((items) => {
            commit('SET_INITIALIZED_TRUE', 'items')
            commit('SET_REFRESHING_FALSE', 'items')
            commit('SET_ITEMS', items.items)
            commit('SET_MAXPAGE', items.total_pages)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'items')
            commit('SET_ERROR_TRUE', 'items')
            reject(err)
          })
      })
    },
    fetchHotProducts ({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'hotItems')
        commit('SET_ERROR_FALSE', 'hotItems')
        if (axiosSource.hotItems) {
          axiosSource.hotItems.cancel()
        }
        axiosSource.hotItems = Axios.CancelToken.source()

        const limit = 20
        let offset = 0
        if (data.page) {
          offset = data.page * limit
        }
        getHotProducts(offset, limit, axiosSource.hotItems.token)
          .then((items) => {
            commit('SET_INITIALIZED_TRUE', 'hotItems')
            commit('SET_REFRESHING_FALSE', 'hotItems')
            commit('SET_HOT_ITEMS', items)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'hotItems')
            commit('SET_ERROR_TRUE', 'hotItems')
            reject(err)
          })
      })
    },
    fetchBonusPointsProducts ({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'bonusPointsItems')
        commit('SET_ERROR_FALSE', 'bonusPointsItems')
        if (axiosSource.bonusPointsItems) {
          axiosSource.bonusPointsItems.cancel()
        }
        axiosSource.bonusPointsItems = Axios.CancelToken.source()

        const limit = 20
        let offset = 0
        if (data.page) {
          offset = data.page * limit
        }
        getBonusPointProducts(offset, limit, axiosSource.bonusPointsItems.token)
          .then((items) => {
            commit('SET_INITIALIZED_TRUE', 'bonusPointsItems')
            commit('SET_REFRESHING_FALSE', 'bonusPointsItems')
            commit('SET_BONUS_POINTS_ITEMS', items)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'bonusPointsItems')
            commit('SET_ERROR_TRUE', 'bonusPointsItems')
            reject(err)
          })
      })
    },
    fetchProductDetails ({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'details')
        commit('SET_ERROR_FALSE', 'details')
        getProduct(data.categoryId, data.productId)
          .then((product) => {
            commit('SET_INITIALIZED_TRUE', 'details')
            commit('SET_REFRESHING_FALSE', 'details')
            commit('SET_DETAILS', product)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'details')
            commit('SET_ERROR_TRUE', 'details')
            reject(err)
          })
      })
    },
    fetchBonusPointsProductDetails ({ commit }, productId) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'bonusPointsDetails')
        commit('SET_ERROR_FALSE', 'bonusPointsDetails')
        getBonusPointsProduct(productId)
          .then((product) => {
            commit('SET_INITIALIZED_TRUE', 'bonusPointsDetails')
            commit('SET_REFRESHING_FALSE', 'bonusPointsDetails')
            commit('SET_BONUS_POINTS_DETAILS', product)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'bonusPointsDetails')
            commit('SET_ERROR_TRUE', 'bonusPointsDetails')
            reject(err)
          })
      })
    },
    setChosenProductVersion ({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_BONUS_CHOSEN_PRODUCT_VERSION', data)
        resolve()
      })
    },
  },
  mutations: {
    SET_INITIALIZED_TRUE: (state, dataName) => {
      state.status[dataName].initialized = true
    },
    SET_REFRESHING_TRUE:
      (state, dataName) => {
        state.status[dataName].refreshing = true
      },
    SET_REFRESHING_FALSE:
      (state, dataName) => {
        state.status[dataName].refreshing = false
      },
    SET_ERROR_TRUE:
      (state, dataName) => {
        state.status[dataName].error = true
      },
    SET_ERROR_FALSE:
      (state, dataName) => {
        state.status[dataName].error = false
      },
    SET_ITEMS:
      (state, payload) => {
        state.items = payload
      },
    SET_MAXPAGE:
      (state, payload) => {
        state.max_page = payload
      },
    SET_HOT_ITEMS:
      (state, payload) => {
        state.hotItems = payload
      },
    SET_BONUS_POINTS_ITEMS:
      (state, payload) => {
        state.bonusPointsItems = payload
      },
    SET_DETAILS:
      (state, payload) => {
        state.details.id = payload.id
        state.details.imageUrl = payload.imageUrl
        state.details.supplierInfoTitle = payload.supplierInfoTitle
        state.details.supplierInfoDescription = payload.supplierInfoDescription
        state.details.name = payload.name
        state.details.description = payload.description
        state.details.californiaProposition65 = payload.californiaProposition65
        state.details.versions = payload.versions
        state.details.supplierName = payload.supplierName
        state.details.terms = payload.terms
      },
    SET_BONUS_POINTS_DETAILS:
      (state, payload) => {
        state.bonusPointsDetails.id = payload.id
        state.bonusPointsDetails.name = payload.name
        state.bonusPointsDetails.description = payload.description
        state.bonusPointsDetails.imageUrl = payload.imageUrl
        state.bonusPointsDetails.californiaProposition65 = payload.californiaProposition65
        state.bonusPointsDetails.versions = payload.versions
      },
    SET_BONUS_CHOSEN_PRODUCT_VERSION:
      (state, payload) => {
        state.bonusPointsChosenVersion.productId = payload.productId
        state.bonusPointsChosenVersion.productVersionId = payload.productVersionId
      },
  },
}

export default product
